<template>
  <div
    class="flex items-center rounded-[12px] border border-[#ebedef]"
    :class="dense ? 'h-[56px] px-3 py-2' : 'px-4 py-2.5'"
  >
    <Avatar :size="40" :src="user?.avatarUrl" />

    <div class="ml-3 min-w-0">
      <div
        class="truncate text-[16px] leading-[22px] font-medium text-gray-800"
      >
        {{ user?.name }}
      </div>
      <div class="truncate text-[13px] leading-[18px] text-gray-500">
        {{ user?.email }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Avatar } from '@dacr/library'

import { useUserStore } from '@/shared/stores/user'

defineProps<{ dense?: boolean }>()

const userStore = useUserStore()
const user = computed(() => userStore.user)
</script>
